import { render, staticRenderFns } from "./PointsPopover.vue?vue&type=template&id=26230ec6&scoped=true"
import script from "./PointsPopover.vue?vue&type=script&lang=js"
export * from "./PointsPopover.vue?vue&type=script&lang=js"
import style0 from "./PointsPopover.vue?vue&type=style&index=0&id=26230ec6&prod&lang=less"
import style1 from "./PointsPopover.vue?vue&type=style&index=1&id=26230ec6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26230ec6",
  null
  
)

export default component.exports